import VolumeDetails from './VolumeDetails';
import InstanceDetails from './InstanceDetails';
import type { SidebarSelectedCardProps } from './volumeDetails.types';

export default function SidebarSelectedCard({ selection }: SidebarSelectedCardProps) {
  if (selection.kind === 'volume') {
    return <VolumeDetails volume={selection.volume} />;
  }

  return <InstanceDetails instanceId={selection.instanceId} vols={selection.vols} />;
}
